import { useMemo } from 'react'
import { useIntl } from 'react-intl'

export const useFormFieldsLabels = () => {
	const { formatMessage } = useIntl()

	return useMemo(
		() => ({
			billingLastName: formatMessage({ id: 'forms_billing_lastname_label' }),
			careOf: formatMessage({ id: 'forms_care_of_label' }),
			city: formatMessage({ id: 'forms_city_label' }),
			collections: formatMessage({ id: 'form_newsletter_collection_label' }),
			communications: formatMessage({ id: 'forms_communications_label' }),
			company: formatMessage({ id: 'forms_company_label' }),
			companyName: formatMessage({ id: 'forms_company_name_label' }),
			country: formatMessage({ id: 'forms_country_label' }),
			countryCode: formatMessage({ id: 'forms_country_label' }),
			description: formatMessage({ id: 'forms_description_label' }),
			dob: formatMessage({ id: 'forms_date_of_birth_label' }),
			email: formatMessage({ id: 'forms_email_label' }),
			emailConfirm: formatMessage({ id: 'forms_confirm_email_label' }),
			emailForgotten: formatMessage({ id: 'forms_email_label' }),
			firstName: formatMessage({ id: 'forms_firstname_label' }),
			fileUpload: formatMessage({ id: 'forms_file_upload_label' }),
			gender: formatMessage({ id: 'forms_gender_label' }),
			giftcardCode: formatMessage({ id: 'forms_giftcard_code_label' }),
			iban: formatMessage({ id: 'forms_iban_label' }),
			jobPosition: formatMessage({ id: 'forms_job_position_label' }),
			lastName: formatMessage({ id: 'forms_lastname_label' }),
			message: formatMessage({ id: 'forms_message_label' }),
			orderEmail: formatMessage({ id: 'forms_email_label' }),
			orderNumber: formatMessage({ id: 'forms_order_number_label' }),
			password: formatMessage({ id: 'forms_password_label' }),
			passwordConfirm: formatMessage({ id: 'forms_password_confirm_label' }),
			passwordCurrent: formatMessage({ id: 'forms_current_password_label' }),
			passwordNew: formatMessage({ id: 'forms_new_password_label' }),
			postCode: formatMessage({ id: 'forms_postcode_label' }),
			privacyPolicy: formatMessage({ id: 'forms_privacy_policy_required' }),
			quoteAdditionalDescription: formatMessage({ id: 'forms_cart_quote_additional_description_label' }),
			quoteCustomerId: formatMessage({ id: 'forms_cart_quote_select_customer_label' }),
			quoteDescription: formatMessage({ id: 'forms_cart_quote_description_label' }),
			quoteName: formatMessage({ id: 'forms_cart_quote_name_label' }),
			quoteNameType: formatMessage({ id: 'forms_cart_quote_name_type_label' }),
			reason: formatMessage({ id: 'forms_reason_label' }),
			region: formatMessage({ id: 'forms_region_label' }),
			regionText: formatMessage({ id: 'forms_region_label' }),
			specialization: formatMessage({ id: 'forms_specialization_label' }),
			state: formatMessage({ id: 'forms_state_label' }),
			street: formatMessage({ id: 'forms_street_label' }),
			streetName: formatMessage({ id: 'forms_street_label' }),
			telephone: formatMessage({ id: 'forms_telephone_label' }),
			username: formatMessage({ id: 'forms_username_label' }),
			vatNumber: formatMessage({ id: 'forms_vat_number_label' }),
			zipcode: formatMessage({ id: 'forms_zipcode_label' }),
		}),
		[formatMessage]
	)
}
